import { Stack, Typography } from '@mui/material';
import { AnalyticsEventName, trackAmplitudeEvent } from '@schooly/analytics';
import { FC, ReactNode, useEffect } from 'react';

type JustificationLabelProps = {
  palette: { primary: string; secondary: string };
  label: string;
  icon: ReactNode;
};

export const JustificationLabel: FC<JustificationLabelProps> = ({ palette, label, icon }) => {
  useEffect(() => {
    trackAmplitudeEvent({
      name: AnalyticsEventName.AttendanceJustificationView,
    });
  }, []);

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={(theme) => ({
        backgroundColor: palette.secondary,
        padding: theme.spacing(0.5, 1),
        borderRadius: theme.spacing(0.5),
      })}
    >
      <Typography variant="h4" color={palette.primary}>
        {label}
      </Typography>
      {icon}
    </Stack>
  );
};
